// [DA-718] A pre-aprovacao de cartao (cobranca ja paga, re-hidratada ao abrir o modal) sobrevive a
// troca de CREDITO <-> DEBITO.
//
// O casamento cobranca<->linha e por VALOR, e vale pra QUALQUER forma de cartao: a maquininha e a
// mesma, o pedido e o mesmo e o dinheiro ja entrou. Ate 11/09/2026 o modal limpava a pre-aprovacao
// a cada mudanca de `valor` OU `forma_pagamento_id` — certo pro valor, cego pra forma: quem tinha
// pago no DEBITO via a linha abrir em CREDITO (a forma declarada no pedido), trocava pra debito e a
// tela APAGAVA a confirmacao, voltando a oferecer "Cobrar na maquininha" numa venda JA PAGA.
//
// Cobranca dupla e' justamente o que a re-hidratacao existe pra impedir. Achado pelo Ruan no
// ORC-007775, onde o cliente ja tinha pago R$ 15,80 no debito.

export const TIPOS_CARTAO = ['cartao_credito', 'cartao_debito'] as const;

export function ehCartao(tipo: string | null | undefined): boolean {
  return tipo === 'cartao_credito' || tipo === 'cartao_debito';
}

/**
 * A pre-aprovacao daquela linha continua valendo depois da mudanca?
 *
 * - valor mudou      -> NAO (o casamento e por valor; a cobranca deixa de cobrir o que a linha pede)
 * - segue em cartao  -> SIM (credito <-> debito nao muda a cobranca que ja foi paga)
 * - saiu do cartao   -> NAO (Pix/dinheiro/crediario nao tem o que reaproveitar da maquininha)
 */
/**
 * A linha ACABOU de virar cartao: existe cobranca ja paga deste pedido que ela deve assumir?
 *
 * A re-hidratacao do modal so casava as linhas que ABRIAM como cartao. Pedido salvo como Pix e pago
 * na maquininha (o operador trocou a forma na tela, a aprovacao chegou e a janela fechou sem
 * Finalizar) reabria em Pix; trocar pra debito nao refazia o casamento e a tela oferecia "Cobrar na
 * maquininha" de novo, com o Finalizar travado. Achado pelo Ruan no ORC-008563 (03/10/2026, R$ 30,55
 * no debito ja aprovado).
 *
 * Casa so por valor EXATO (centavos de tolerancia) — a cobertura parcial da abertura nao entra aqui:
 * reduzir a linha sozinho e decisao que a abertura toma com o pedido inteiro na mao, nao um efeito
 * de trocar o select. Cobranca ja assumida por outra linha (`jaUsadas`) nao casa duas vezes.
 */
export function cobrancaPagaParaLinha<T extends { valor_alocado: string | number; cobranca_id: number | string | null }>(args: {
  tipoNovo: string | null | undefined;
  valorLinha: number;
  cobrancas: T[];
  jaUsadas: number[];
}): T | null {
  if (!ehCartao(args.tipoNovo)) return null;
  const usadas = new Set(args.jaUsadas);
  return args.cobrancas.find((c) =>
    c.cobranca_id != null
    && !usadas.has(Number(c.cobranca_id))
    && Math.abs(Number(c.valor_alocado) - args.valorLinha) < 0.05,
  ) ?? null;
}

export function preAprovacaoCartaoSobrevive(args: {
  trocouValor: boolean;
  tipoNovo: string | null | undefined;
}): boolean {
  if (args.trocouValor) return false;
  return ehCartao(args.tipoNovo);
}
